<template>
  <div class="detail-row" @click="goToRoute">
    <font-awesome-icon :icon="icon" class="sliderIcon" />
    <div class="detailtitle">{{ title }}</div>

    <div class="value">{{ value }}</div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  props: {
    icon: {},
    title: {},
    route: {},
    value: {
      default: "",
      type: String,
    },
  },
  methods: {
    /**
     * open a route when click on menu option
     */
    goToRoute() {
      if (this.route != undefined) {

        if (this.$route.path != this.route) {
          window.scrollTo(0, 0);
          if (this.route.search("/") == 0) {
            this.$router.push(this.route);
          } else {
            window.open(this.route);
          }
        }
        this.$emit("closeSlider");
      }
    },
  },
};
</script>
<style scoped>
.faicon {
  float: right;
  width: 50px;
}

.detailtitle {
  float: right;
  margin-right: 10px;
  padding-bottom: 10px;
  padding-right: 10px;
  white-space: normal;
  width: 100%;
  font-size: 14px;
  top: 4px;
  position: relative;
  border-bottom: 1px solid rgb(51, 88, 132);
}

.value {
  float: left;
  border-bottom: 1px solid rgb(51, 88, 132);
  top: 4px;
  position: relative;
  padding-left: 15px;
  font-size: 16px;
}

.detail-row {
  display: flex;
  padding: 10px 30px 0 0;
  font-size: 14px;
  color: white;
}

.detail-row:hover {

  color: orangered !important;
}

.bar>hr {
  overflow: unset;
}

svg {
  width: 1.3em !important;

  top: 4px !important;
  position: relative;
}

.sliderIcon {
  font-size: 1.5em;
}
</style>
